export type ImageInputTheme = {
  width?: string;
  height?: string;

  minHeight?: string;

  maxWidth?: string;

  maxImageHeight?: string;
};

export enum DragState {
  Valid = 'valid',
  Invalid = 'invalid',
  Default = 'default',
}

export interface ImageInputProps {
  disabled?: boolean;
  onChange?: (file: File) => void;
  selectedImage?: File | string | null;
  allowedMimeTypes?: string[];
  theme?: ImageInputTheme;
}
